import React, {FC} from 'react'

import {TrackAppEvent} from 'src/lib/Analytics/analytics_compat'
import {AppEvents} from 'src/lib/Analytics/app_events'
import {usePageViewedAnalytics} from 'src/lib/Analytics/usePageViewedAnalytics'
import {logOfferApplicationErrorAndShowException} from 'src/products/general/OfferApplicationWorkflow/OfferApplication.utils'
import {IDScanGQLContainer} from 'src/products/loans/IDScan/IDScanGQLContainer'
import {WorkflowPreReqFulfillScreenProps} from 'src/workflows/types'

export const IDScanWorkflowContainer: FC<WorkflowPreReqFulfillScreenProps> = ({
  onPreReqFulfilled,
}) => {
  usePageViewedAnalytics({
    eventName: AppEvents.Name.id_photo_screen_viewed,
    eventCategory: AppEvents.Category.Application,
  })

  const handleOnPreReqFulfilled = async (): Promise<void> => {
    try {
      TrackAppEvent(AppEvents.Name.id_photo_submitted, AppEvents.Category.Application)
      await onPreReqFulfilled()
    } catch (e) {
      logOfferApplicationErrorAndShowException(
        e,
        'Error while viewing id photo upload in Workflows',
      )
    }
  }

  return <IDScanGQLContainer onComplete={handleOnPreReqFulfilled} />
}
